import "leaflet/dist/leaflet.css";
import L from 'leaflet';
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';

const position = [-33.41919549180762, -70.60103831558587];

const markerIcon = new L.Icon({
    iconUrl: "/images/marker-icon.png",
    shadowUrl: "/images/marker-shadow.png"
});

export default function MapComponent() {
    return (
        <MapContainer className="map" center={position} zoom={17} scrollWheelZoom={false}>
            <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <Marker position={position} icon={markerIcon} alt="Marcador de la academia en el mapa" >
                <Popup>
                    MUSASHI Escuela de Grappling - BJJ
                    <br />
                    Av. Hernando de Aguirre 162 of. 204, Providencia
                </Popup>
            </Marker>
        </MapContainer>
    );
};
